<!-- Trigger: a standard control — icon when nothing is selected, the label chips when there are some -->
<cm-ui-standard-button
  header
  class="label-trigger-btn"
  [class.filter-mode]="filterMode"
  [icon]="triggerIcon"
  [matMenuTriggerFor]="labelMenu"
  [matTooltip]="'ADMIN.labels.button.tooltip' | translate">
  @if (filterMode) {
    @if (filterSelectedUuids.length > 0) {
      <span class="label-summary">
        @for (label of selectedFilterLabels; track label.uuid; let i = $index) {
          @if (i < maxVisible) {
            <app-label-chip [label]="label" [matTooltip]="label.labelDefinition.name + ': ' + label.name" />
          }
        }
        @if (filterSelectedUuids.length > maxVisible) {
          <span class="label-more">+{{ filterSelectedUuids.length - maxVisible }}</span>
        }
      </span>
    }
  } @else {
    @if (sortedAttachedLabels().length > 0) {
      <span class="label-summary">
        @for (ol of sortedAttachedLabels(); track ol.uuid; let i = $index) {
          @if (i < maxVisible) {
            <app-label-chip
              [label]="ol.label"
              [matTooltip]="ol.label.labelDefinition.name + ': ' + ol.label.name" />
          }
        }
        @if (sortedAttachedLabels().length > maxVisible) {
          <span class="label-more">+{{ sortedAttachedLabels().length - maxVisible }}</span>
        }
      </span>
    }
  }
</cm-ui-standard-button>

<!-- Top-level menu: one item per label definition (type) -->
<mat-menu #labelMenu="matMenu">
  <ng-template matMenuContent>
    @if (loading()) {
      <div class="flex justify-center p-3">
        <mat-spinner diameter="20" />
      </div>
    }

    @if (!loading() && sortedDefinitions().length === 0) {
      <div class="px-4 py-2 text-gray-400 text-sm">
        {{ 'ADMIN.labels.button.noDefinitions' | translate }}
      </div>
    }

    @if (filterMode && filterSelectedUuids.length > 0) {
      <button mat-menu-item (click)="clearFilterSelection()">
        <span class="flex items-center gap-2">
          <mat-icon class="type-icon">clear</mat-icon>
          <span>{{ 'ADMIN.labels.filter.clearSelection' | translate }}</span>
        </span>
      </button>
      <mat-divider />
    }

    @for (definition of sortedDefinitions(); track definition.uuid) {
      <button
        mat-menu-item
        [matMenuTriggerFor]="subMenu"
        class="label-type-item">
        <span class="flex items-center gap-2">
          <mat-icon class="type-icon">{{ definitionIcon(definition) }}</mat-icon>
          <span>{{ definition.name }}</span>
          @if (filterMode && filterCountFor(definition) > 0) {
            <span class="attached-badge">{{ filterCountFor(definition) }}</span>
          }
          @if (!filterMode && attachedCountFor(definition) > 0) {
            <span class="attached-badge">{{ attachedCountFor(definition) }}</span>
          }
        </span>
      </button>

      <mat-menu #subMenu="matMenu">
        <ng-template matMenuContent>
          @for (label of definition.labels || []; track label.uuid) {
            <button
              mat-menu-item
              class="label-menu-item"
              [ngClass]="{ 'attached': filterMode ? isFilterSelected(label.uuid) : isAttached(label.uuid) }"
              (click)="filterMode ? toggleFilterLabel(label) : toggleAndClose(label)">
              <span class="flex items-center gap-2 w-full">
                @if (definition.renderType === 'COLOR') {
                  <span class="color-dot-sm" [style.background-color]="label.color || '#6b7280'"></span>
                } @else {
                  <mat-icon class="text-base">label</mat-icon>
                }
                <span class="flex-1">{{ label.name }}</span>
                @if (filterMode ? isFilterSelected(label.uuid) : isAttached(label.uuid)) {
                  <mat-icon class="check-icon">check</mat-icon>
                }
              </span>
            </button>
          }
        </ng-template>
      </mat-menu>
    }
  </ng-template>
</mat-menu>
